import './DetailGlassLoading.css';

const Bone = ({ className = '' }) => <span className={`detail-glass-bone ${className}`} />;

const DetailGlassLoading = ({ type = 'movie' }) => (
  <main className='detail-glass-loader' role='status' aria-live='polite' aria-label={`Loading ${type} details`}>
    <section className='detail-glass-hero'>
      <div className='detail-glass-orb detail-glass-orb-one' />
      <div className='detail-glass-orb detail-glass-orb-two' />
      <div className='detail-glass-visual'><div className='detail-glass-poster'><Bone /></div></div>
      <div className='detail-glass-copy'>
        <Bone className='detail-glass-kicker' />
        <Bone className='detail-glass-title' />
        <div className='detail-glass-facts'><Bone /><Bone /><Bone /><Bone /></div>
        <div className='detail-glass-lines'><Bone /><Bone /><Bone /></div>
        <div className='detail-glass-actions'><Bone /><Bone /></div>
      </div>
    </section>

    <section className='detail-glass-content'>
      <div className='detail-glass-tabs'><Bone /><Bone /><Bone /></div>
      <div className='detail-glass-meta'>
        {[0, 1, 2, 3].map((item) => (
          <div key={item}><Bone /><Bone /></div>
        ))}
      </div>
      <div className='detail-glass-section-heading'><div><Bone /><Bone /></div><Bone /></div>
      <div className='detail-glass-card-row'>
        {[0, 1, 2, 3, 4].map((item) => (
          <div className='detail-glass-card' key={item}>
            <Bone className='detail-glass-card-poster' />
            <Bone className='detail-glass-card-title' />
            <Bone className='detail-glass-card-subtitle' />
          </div>
        ))}
      </div>
    </section>
    <span className='visually-hidden'>Loading {type} details</span>
  </main>
);

export default DetailGlassLoading;
